import { PhoneService } from '@superdispatch/phones';
import { z } from 'zod';

const zodString = z
  .string()
  .nullish()
  .transform((value) => value ?? '');

export type TerminalDTO = z.infer<typeof terminalSchema>;

export const terminalSchema = z.object({
  guid: zodString,
  name: zodString,
  street: zodString,
  city: zodString,
  state: zodString,
  zip: zodString,
  contact_name: zodString,
  phone_number: zodString,
});

function requiredString(max: number) {
  return z
    .string()
    .min(1, 'This field is required')
    .max(max, `Maximum length is ${max} characters`)
    .prefault('');
}

const terminalPhone = z
  .string()
  .trim()
  .min(1, 'This field is required')
  .superRefine(async (value, ctx) => {
    const message = await PhoneService.validate(value);

    if (message) {
      ctx.addIssue({ code: 'custom', message });
    }
  })
  .prefault('');

export const terminalEditSchema = z.object({
  guid: z.string().prefault(''),
  name: requiredString(100),
  street: requiredString(100),
  city: requiredString(50),
  state: requiredString(50),
  zip: requiredString(20),
  contact_name: requiredString(25),
  phone_number: terminalPhone,
});
